<template>
  <eagle-list
    @updatePopupSelectData="updatePopupSelectData"
    :list-key="listKey"
  ></eagle-list>
</template>

<script lang="babel" type="text/babel">
import listMixin from '@/components/list/mixins/listMixin'
import listConfig from './memberListConfig'
export default {
  mixins: [listMixin],
  data: () => ({
    listKey: 'member-selector',
    meta: {},
  }),
  methods: {
    updatePopupSelectData(data) {
      this.$emit('updateData', data)
    },
    async beforeIndex() {
      await Promise.all([])
    },
    async indexApi(params) {
      return await this.$api.collection.memberApi.index(params)
    },
    getListConfig() {
      return listConfig
    },
  },
}
</script>

<style lang="sass" type="text/sass" scoped></style>
